// Options
//

// @ngInject
Directives.BasicTooltip = function BasicTooltip($timeout, Tippy) {

    // default configuration
    var _defaultValues = {
        animation: "shift-away",
        duration: "200",
        arrow: true,
        theme: 'nx-tippy',
        dynamicTitle: true,
        maxWidth: '300px',
        popperOptions: {
            modifiers: {
                preventOverflow: {
                    escapeWithReference: true
                }
            }
        }
    };

    return {
        restrict: 'A',
        link: function(scope, element, attr) {

            // default
            var _customOptions = {};

            // set placement
            if(attr.placement) {
                _customOptions['placement'] = attr.placement;
            }

            if (attr.maxWidth) {
                _customOptions['maxWidth'] = attr.maxWidth;
            }

            var _options = Object.assign({}, _defaultValues, _customOptions);

            $timeout(() => {
                Tippy(element[0], _options);
            });
        }
    };
};